import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ReceiptMaster } from '../model/ReceiptMaster.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import { MessageService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {

  recieptMaster: ReceiptMaster = new ReceiptMaster();
  studentMaster: StudentMaster = new StudentMaster();
  pageSize: number = 6;
  pageNumber: number = 0;
  totalRecords: number = 0;
  showbtn: boolean = true;
  recieptMasterList: ReceiptMaster[] = [];

  constructor(private authService: AuthService, private router: Router, private mainService: MainserviceService,
    private messageService: MessageService,public spinnerService: NgxSpinnerService) { }

  ngOnInit() {
    this.spinnerService.show()
    this.getRecieptList(this.studentMaster)
  }


  getRecieptList(studentMaster: StudentMaster) {



    this.recieptMaster.studentMaster = new StudentMaster();
    let student = this.authService.getUserSession();
    this.recieptMaster.studentMaster.studentMasterId = student.studentMasterId;


    this.recieptMaster.pageNumber = this.recieptMaster.pageNumber
      ? this.recieptMaster.pageNumber
      : this.pageNumber;
    this.recieptMaster.pageSize = this.recieptMaster.pageSize
      ? this.recieptMaster.pageSize
      : this.pageSize;

    this.mainService.getReceiptMasterList(this.recieptMaster).subscribe(data => {
      this.recieptMasterList = data;
      this.spinnerService.hide()
      this.getRecieptMasterListLength();
    })

  }

  getRecieptMasterListLength() {

    this.mainService.getReceiptMasterListLength(this.recieptMaster).subscribe(data => {
      this.totalRecords = data;

    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.recieptMaster = JSON.parse(jsonString);

      }


    })
  }


  incrementPage() {

    this.recieptMaster.pageNumber = this.recieptMaster.pageNumber
    this.recieptMaster.pageSize = this.recieptMaster.pageSize + 6;

    this.getRecieptList(this.studentMaster);


    if (this.recieptMaster.pageSize >= this.totalRecords) {

      this.showbtn = false;
    }
  }

  downloadFile(fileUrl: string) {

    if (fileUrl === null) {
      alert('No PDF to downlaod');
      return;
    }

    var fileUrlSplit = fileUrl.split("/");

    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length - 1]);

  }


  downloadReciept(recieptMaster: ReceiptMaster) {

    if (recieptMaster.receiptFilePath != null) {
      this.downloadFile(recieptMaster.receiptFilePath);
    } else {
      this.messageService.add({ severity: 'error', summary: 'No Reciept', detail: 'available' });
    }
  }


}
